import { API_URL } from "config";
import Http from "util/https";
import Notify from "config/notify";
import { getUserType } from "util/auth";
import { RequestParam, SupplierStockSingle } from "../types";
import { removeEmptyValues } from "../utils/common";

type Arg = {
  stockList: SupplierStockSingle[];
  isSupplier: boolean;
  supplierCd?: string;
};

/**
 * 在庫数を更新するAPI
 * @param stockList 在庫情報
 */
export default async function updateStockApi({ stockList, isSupplier, supplierCd }: Arg) {
  console.log("updateStock:", stockList);
  let params: RequestParam;
  if (isSupplier) {
    // 仕入先の場合
    params = {
      stock_list: stockList.map((s) => {
        // 倉庫毎に数量を入れる
        const arr = s.supplierWarehouses!.filter(sw => sw.code != null && sw.code !== "").map(sw => removeEmptyValues({
          depot_cd: sw.code,
          item_cd: s.productCd,
          jan_cd: s.JANCd,
          quantity: sw.amount,
          arrival_date: s.arrivalDate ? s.arrivalDate.replaceAll("/", "-") : "", // APIの仕様上空文字だった場合nullである必要がある
        }));
        return arr;
      }).flat(),
    };
  } else {
    // 外部倉庫の場合
    params = {
      stock_list: stockList.map((s) => (removeEmptyValues({
        item_cd: s.productCd,
        jan_cd: s.JANCd,
        quantity: s.amountCount,
        arrival_date: s.arrivalDate ? s.arrivalDate.replaceAll("/", "-") : "", // APIの仕様上空文字だった場合nullである必要がある
      }))),
    };
  }
  if (supplierCd) {
    params.code = supplierCd;
  }
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/stock/update/records`;
  const response = await http.post<null>(url, params);
  if (response.status === 200) {
    Notify.setNotification({
      show: true,
      title: "更新が完了しました",
      confirmLabel: "OK",
      actionsPosition: "end",
    });
  }
}
